import React from 'react';
import { FormattedMessage } from 'react-intl';
import {biobankConsentVersion, biobankRefusalVersion} from "../../../utils/BioBankUtil";

/**
 * Print choice box for yes/no value
 * @param label The label of the question
 * @param value The value of the question, either "YES" or "NO"
 * @returns {*}
 * @constructor
 */
const ChoiceSection = ({ label, value }) => (
  <div className={'choice-section'}>
    - {label}
    <div style={{ overflow: 'auto' }}>
      <div style={{ width: '100px', float: 'left' }}>
        <div className={'choice-box'}>{value === 'YES' && 'X'}</div>
        <FormattedMessage id="yes" />
      </div>
      <div style={{ width: '100px', float: 'left' }}>
        <div className={'choice-box'}>{value === 'NO' && 'X'}</div>
        <FormattedMessage id="no" />
      </div>
    </div>
  </div>
);

/**
 * Prefilled value field for e.g. hetu, current date etc.
 *
 * @param messageId The react-intl message id given as label
 * @param value The value to be printed as prefilled
 * @returns {*}
 * @constructor
 */
const PrefilledValue = ({ messageId, value }) => (
  <div style={{ overflow: 'auto', marginBottom: '10px' }}>
    <div style={{ width: '200px', float: 'left' }}>
      <FormattedMessage id={messageId} />
    </div>
    <div style={{ float: 'left' }} className={'fill-line'}>
      {value}
    </div>
  </div>
);

export const Consent = ({
  hetu,
  incidental,
  recontact,
  wholeName,
  attachments,
  address,
  date,
  version,
  headerText,
  contentText,
  incidentalText,
  recontactText,
}) => (
  <div id={'biopankkiPrintContainer'}>
    <div className={'printContent'}>
      <div dangerouslySetInnerHTML={{ __html: attachments[0].text }} />
    </div>
    <div className={'page-break'} />
    <div className={'printContent'}>
      <h1>{headerText}</h1>

      {contentText.split('\n').map((row, i) => (
        <p key={i}>{row}</p>
      ))}

      <div className="biobankki-box">

        <ChoiceSection label={incidentalText} value={incidental} />

        <ChoiceSection label={recontactText} value={recontact} />

        <PrefilledValue
          messageId={'biobank.agreement.part2.social.security.number'}
          value={hetu}
        />

        <PrefilledValue
          messageId={'biobank.agreement.part2.consent.givers.full.name'}
          value={wholeName}
        />

        <PrefilledValue
          messageId={'biobank.agreement.part2.address'}
          value={address}
        />

        <PrefilledValue
          messageId={'biobank.agreement.part2.date'}
          value={date}
        />
      </div>
      <p>
        <FormattedMessage id="biobank.agreement.part2.aknowledgement.information.request" />
        <br />
        <FormattedMessage id="biobank.agreement.part2.request.contact.information.see.above" />
        <br />
        {!(version === biobankConsentVersion || version === biobankRefusalVersion) && (
          <FormattedMessage id="biobank.agreement.part2.biobank.organization.information" />
        )}
      </p>
    </div>
  </div>
);
